var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"d-flex align-items-center"},[_c('div',[_c('a',{attrs:{"href":"","target":"_blank"}},[_vm._v("© "),_c('strong',[_vm._v("Grupo NovaescolaBrasil")]),_vm._v(" "+_vm._s(new Date().getFullYear()))])])])}
var staticRenderFns = []

export { render, staticRenderFns }